

const Vision = () => {

  return (
    <section className="w-[90%] mx-auto flex flex-col lg:flex-row gap-14 justify-center lg:items-center pt-10 md:pt-24">
      {/* CONTENIDO */}
      <div className="flex flex-col lg:pl-20">
        <h2 className="text-[25px] lg:text-[35px] leading-10 mt-5 max-w-[500px] font-tommy-medium uppercase">Visión</h2>
        <p className="text-base mt-4 font-tommy-light max-w-[600px]">Ser una plataforma eficiente y transparente de los proyectos municipales de Huehuetenango a través de la agilización de carga de documentos para cumplir las fases que conlleva a la ejecución de los proyectos municipales.</p>
      </div>
      {/* IMAGEN */}
      <div className="flex justify-center w-full lg:w-[673px] lg:h-[328px] lg:pr-20">
        <img src="/images/vision.jpeg" className="object-cover object-center" />
      </div>
    </section>
  );
}

export default Vision;